import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "beforeButtonEnabled"];
import { useEffect, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UITourBackButton from 'ui-shepherd-react/button/UITourBackButton';
import OnboardingTourFinishButton from './OnboardingTourFinishButton';
import { BACK, FINISH, NEXT } from '../constants/TourActions';
import SentryManager from '../manager/SentryManager';
import { useTourContext } from '../hooks/tour';
import { jsx as _jsx } from "react/jsx-runtime";
export default function OnboardingTourButton(_ref) {
  let {
      action,
      beforeButtonEnabled
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [disabled, setDisabled] = useState(() => typeof beforeButtonEnabled === 'function');
  const {
    tour
  } = useTourContext();
  const stepId = tour.getStep() || 'unknown';
  const tourId = tour.getTour() || 'unknown';
  useEffect(() => {
    if (typeof beforeButtonEnabled === 'function') {
      beforeButtonEnabled().then(() => setDisabled(false)).catch(error => SentryManager.reportOnboardingTourButtonButtonError(error, tourId, stepId));
    }
  }, [beforeButtonEnabled, tourId, stepId]);
  switch (action) {
    case BACK:
      return /*#__PURE__*/_jsx(UITourBackButton, Object.assign({
        disabled: disabled
      }, props));
    case NEXT:
      return /*#__PURE__*/_jsx(UITourNextButton, Object.assign({
        disabled: disabled
      }, props));
    case FINISH:
      return /*#__PURE__*/_jsx(OnboardingTourFinishButton, Object.assign({
        disabled: disabled
      }, props));
    default:
      return /*#__PURE__*/_jsx(Button, Object.assign({
        disabled: disabled
      }, props));
  }
}